import { PlatformSlug } from 'constants/consts'
import { enabledOn, isFeatureAvailable } from 'platformConfig'

export const CARS_QUESTIONS_CONFIG = enabledOn(PlatformSlug.CARSBooster)

export const isCarsQuestionsAvailable = (slug?: PlatformSlug) => isFeatureAvailable(CARS_QUESTIONS_CONFIG, slug)
